import { Box, Container } from '@mui/material';
import React from 'react';
import AccountDetails from './AccountDetails';
import { AdminHeader } from '../AdminHeader/AdminHeader';

const AdminAccount = () => {
  return (
    <Box>
      <AdminHeader />
      <Box p={2}>
        <AccountDetails />
      </Box>
    </Box>
  );
};

export default AdminAccount;
